import * as InvoiceQueries from '../../graphQueries/invoices'

export const getDraftsAndInvoices = () => {
  return InvoiceQueries.getAllInvoices().then((data: any) => {
    return data.data.drafts.length + data.data.invoices.length
  })
}

export const getDraftCount = (): Promise<number> => {
  return InvoiceQueries.getAllInvoices().then((data: any) => {
    return data.data.drafts.length
  })
}

export const getInvoiceCount = (): Promise<number> => {
  return InvoiceQueries.getAllInvoices()?.then((data: any) => {
    return data.data.invoices.length
  })
}

export const getCurrentMonthInvoiceCount = (oldSubEndDate: string): Promise<number> => {
  const firstOfMonth = new Date()
  firstOfMonth.setDate(1)
  const subEndDate = oldSubEndDate !== '' ? new Date(oldSubEndDate) : new Date(0)
  const testDate = subEndDate > firstOfMonth ? subEndDate : firstOfMonth
  const isCounted = (date) => {
    const issueDate = new Date(date)
    return (
      issueDate.getFullYear() === testDate.getFullYear() &&
      issueDate.getMonth() === testDate.getMonth() &&
      issueDate.getDate() >= testDate.getDate()
    )
  }
  return InvoiceQueries.getAllInvoices().then((result) => {
    const filtered = Object.values(result.data?.invoices)
      .flat(1)
      .filter(({ invoiceNumber, issueDate }) => {
        return !(invoiceNumber && invoiceNumber.toUpperCase().startsWith('TEST-')) && isCounted(issueDate)
      })
    return filtered.length
  })
}
